@import '_base.css';

:root {
  --spw-ds-primary: var(--spw-color-themes-teal-teal-700);
  --spw-ds-variant: var(--spw-color-themes-teal-teal-800);
  --spw-ds-active: var(--spw-color-themes-teal-teal-900);
  --spw-ds-cta-outlined-bg-hover: var(--spw-color-themes-teal-teal-50);
  --spw-ds-cta-outlined-stroke-hover: var(--spw-color-themes-teal-teal-700);
  --spw-ds-cta-outlined-bg-active: var(--spw-color-themes-teal-teal-100);
  --spw-ds-cta-outlined-stroke-active: var(--spw-color-themes-teal-teal-800);
}
